import { useQuery } from 'react-query';
import { dsoCheckoutService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useRetrieveDsoShippingAddresses = () => {
  return useQuery(
    [ServerStateKeysEnum.dsoShippingAddresses],
    () => {
      return dsoCheckoutService.getShippingAddresses();
    },
    {
      staleTime: Infinity,
    }
  );
};
